export default [
  {
    name: 'survey',
    path: '/survey',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Pesquisa de Satisfação',
      icon: 'dvr',
      label: 'Pesquisa de Satisfação',
      permission: ['survey.add', 'survey.control']
    }
  }
]
